/* import __COLOCATED_TEMPLATE__ from './email-part-shell.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import templateOnlyComponent from '@ember/component/template-only';
import { type EmailMetadata } from 'embercom/objects/inbox/renderable/email-metadata';

interface Signature {
  Args: {
    metadata?: EmailMetadata;
  };
  Blocks: {
    default: [];
  };
}

const EmailPartShell = templateOnlyComponent<Signature>();
export default EmailPartShell;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::PartGroups::EmailPartShell': typeof EmailPartShell;
    'inbox2/conversation-stream/part-groups/email-part-shell': typeof EmailPartShell;
  }
}
